import * as types from '../constants/ActionTypes';
import { INITIAL_STATE } from '../constants/InitialState';

export function DataReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    // EVENTS TYPES
    case types.ADD_EVENTS:
      return {
        ...state,
        events: payload.events,
        eventsLoading: false,
      };

    case types.ADD_EVENT:

      return {
        ...state,
        events: [payload, ...state.events],
      };

    case types.UPDATE_EVENT:
      const eventsWithoutCurrent = state.events.filter(event => event.id !== payload.id);
      const updatedEvents = [payload, ...eventsWithoutCurrent];

      return {
        ...state,
        events: updatedEvents
      }

    case types.DELETE_EVENT:
      const newListEvents = state.events.filter((event) => event.id !== payload.id);

      return {
        ...state,
        events: newListEvents,
      };

    case types.EVENTS_LOADING:
      return {
        ...state,
        eventsLoading: payload,
      };

    // CHANNEL TYPES
    case types.ADD_ALL_CHANNELS:
      return {
        ...state,
        channels: payload,
      };

    case types.ADD_CHANNEL:
      return {
        ...state,
        channels: [...state.channels, payload],
      };

    case types.DELETE_CHANNEL:
      const newListChannels = state.channels.filter((channel) => channel.id !== payload.id);

      return {
        ...state,
        channels: newListChannels,
      };

    case types.DELETE_CONTRIBUTOR:
      const updatedChannels = state.channels.map(channel => {
        if (channel.id === payload.id) {
          return {
            ...channel,
            ownerId: payload.contributors
          }
        }
        return channel; 
      });

      return {
        ...state,
        channels: updatedChannels
      }

    // CHAT TYPES
    case types.ADD_CHAT_COMPANION:
      return {
        ...state,
        chats: payload,
      };

    case types.ADD_ALL_CHATS:
      return {
        ...state,
        allChats: payload,
    };

    case types.DELETE_ALL_CHATS:
      return {
        ...state,
        allChats: [],
    };

    case types.UPDATE_CHAT_STATUS:
      const updateAllChats = [...state.allChats];
      const index = updateAllChats.findIndex(function(element){
        if (element.chatId === payload.chatId) {
          return true;
        }
        return false;
      });
      updateAllChats[index] = payload.chat;
      
      return {
        ...state,
        allChats: []
      }

    case types.UPDATE_MESSAGE_NOTIFICATION:
      return {
        ...state,
        messageNotification: payload
      }

    // SUBSCRIPTIONS TYPES
    case types.ADD_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: payload
      };

    case types.SUBSCRIBE_CHANNEL_START:
      return {
        ...state,
        subscribeOptions: {
          subscribeLoading: true,
          error: false,
          messageType: null
        }
      };

    case types.SUBSCRIBE_CHANNEL_SUCCESS:
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          ...payload
        },
        subscribeOptions: {
          subscribeLoading: false,
          error: false,
          messageType: 'success'
        },
      };

    case types.SUBSCRIBE_CHANNEL_FAIL:
      return {
        ...state,
        subscribeOptions: {
          subscribeLoading: false,
          error: payload,
          messageType: 'error'
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/DataReducer.js